import {ForYouReviewCommentItem} from '../commenting/review-comments/ForYouReviewComment'
import {useRequestedChangesReviews} from './data/use-requested-changes-reviews'

export function ChangesRequested() {
  const changesRequestedReviews = useRequestedChangesReviews()

  if (changesRequestedReviews.length === 0) {
    return null
  }

  return (
    <>
      {changesRequestedReviews.map(reviewSummary => (
        <ForYouReviewCommentItem key={reviewSummary.id} reviewSummary={reviewSummary} />
      ))}
    </>
  )
}
